module.exports = __webpack_public_path__ + "img/mcl.3d3b1fcf.png";